import React from 'react';
import { Badge } from 'reactstrap';

import { MandateStatus, MANDATE_STATUS_OPTIONS } from '~direct-debits/models';

interface ComponentProps {
  row: { status: MandateStatus };
}

// Single-source-of-truth for labels lives in MANDATE_STATUS_OPTIONS; the badge owns
// only the colour mapping, which is UI-specific and not relevant to filter dropdowns.
const statusLabelByStatus: Record<MandateStatus, string> = Object.fromEntries(
  MANDATE_STATUS_OPTIONS.map((option) => [option.id, option.name]),
) as Record<MandateStatus, string>;

const statusColorByStatus: Record<MandateStatus, string> = {
  active: 'success',
  pending: 'warning',
  none: 'secondary',
};

const MandateStatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const label = statusLabelByStatus[row.status] ?? statusLabelByStatus.none;
  const color = statusColorByStatus[row.status] ?? statusColorByStatus.none;
  return (
    <Badge color={color} data-cy={`dd-mandate-status-${row.status}`}>
      {label}
    </Badge>
  );
};

export default MandateStatusBadge;
